import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ContractMasterGroupService } from '../proxy/controlling/controllers/contract-master-group.service';
import { ProcessService } from '../proxy/controlling/controllers/process.service';

FieldBuilder.setNamespace('Controlling');

export const CONTRACTTYPEGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ContractTypeGroup.Name')
    .required()
    .maxLength(30)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ContractTypeGroup.Code')
    .required()
    .maxLength(12)
    .build(),
  FieldBuilder.foreignKey(
    'contractMasterGroupId',
    'Entity.ContractMasterGroup',
    ContractMasterGroupService
  )
    .displayFromNested('contractMasterGroup.name')
    .sortBy('contractMasterGroup.name')
    .build(),
  FieldBuilder.foreignKey(
    'processId',
    'Entity.Process',
    ProcessService
  )
    .displayFromNested('process.name')
    .sortBy('process.name')
    .build(),
];

export const CONTRACTTYPEGROUP_CONFIG = {
  entityName: 'ContractTypeGroup',
  localizationKey: 'Controlling::Entity.ContractTypeGroup',
  fields: CONTRACTTYPEGROUP_FIELDS,
  permission: 'ControllingContract.ContractTypeGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
